'use client';

import { useContext } from 'react';
import { FinancialStatusContext } from './context/financial-status-context';

export default function ToggleLanguage() {
	const financialContext = useContext(FinancialStatusContext);

	return (
		<div className="bg-UC-blue-100 flex w-3/4 grow items-center p-3 md:w-full">
			<div
				className={`min-w-[50px] text-sm  ${financialContext.language === 'en' ? 'font-semibold text-black' : 'text-black transition-all duration-200 ease-in-out hover:cursor-pointer hover:font-semibold'}`}
				onClick={() => financialContext.setLanguage('en')}
			>
				English
			</div>
			<div className="ml-1 mr-2 h-5 w-0.5 bg-black" />
			<div
				className={`min-w-14 text-sm  ${financialContext.language === 'es' ? 'font-semibold text-black' : 'text-black transition-all duration-300 ease-in-out hover:cursor-pointer hover:font-semibold'}`}
				onClick={() => financialContext.setLanguage('es')}
			>
				Español
			</div>
		</div>
	);
}
